<template>
    <div>
        <div class="text-center col-12" v-show="isLoading">
            <span class="spinner-border" role="status"></span>
        </div>
        <div v-if="!isLoading && errorMessage" class="alert alert-warning" v-text="errorMessage"></div>
        <div v-show="!isLoading && !errorMessage">
            <div v-if="showTSK">
                <TskList></TskList>
            </div>
            <div v-if="showTree">
                <StandardList></StandardList>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import Store from '../../state/teachingCardStore';
import TskList from './TskList';
import StandardList from './StandardList';

const props = defineProps({
    lessonhistory: String,
    isapp: String,
    auth: String
});

const isLoading = computed(() => Store.isLoading());
const isLessonHistory = computed(() => Store.isLessonHistory());
const showTSK = computed(() => Store.showTSK());
const showTree = computed(() => Store.showTree());
const errorMessage = computed(() => Store.getErrorMessage());

onMounted(() => {
    const isLessonHistory = props.lessonhistory === '1';
    const isApp = props.isapp === '1';
    const auth = props.auth;
    Store.init(isLessonHistory, isApp, auth);
});
</script>